/* eslint-disable import/prefer-default-export */

import { http } from './fetch-wrapper';
import { apiUrls } from './index';


export const TT_MAP = {
  REGISTRATION: 'REGISTRATION',
  RESET_PASSWORD: 'RESET_PASSWORD',
};

/**
 *
 * @param {string} tokenValue
 * @param {string} tt
 * @return {Promise<*>}
 */
export function token(tokenValue, tt) {
  const queryParams = new URLSearchParams();

  queryParams.append('tkn', tokenValue);

  queryParams.append('tt', tt);

  return http(`${apiUrls.TOKEN}?${queryParams.toString()}`, {
    method: 'GET',
  });
}



// WEBPACK FOOTER //
// ./api/tokenValidation.js